import styled, { css, keyframes } from "styled-components";
import { MenuColor } from "../../../tournament/hook/useEditTournament";

export const Circle = styled.svg<{ break: boolean }>`
  position: absolute;
  transform: rotate(0.25turn);
  width: 856px;
  height: 856px;
  background-color: black;
  border-radius: 438px;
  box-shadow: ${({ break: isBreak }) =>
    !isBreak
      ? "0px 0px 50px 5px rgba(255, 255, 255, 0.5), 0px 0px 80px 5px #6436e7"
      : "none"};
  circle {
    fill: none;
    stroke-width: 25;
    stroke-linecap: round;
  }

  .background {
    stroke: rgba(240, 240, 240, 0.2);
  }

  .progress {
    stroke: ${({ break: isBreak }) => (!isBreak ? "#b2bce6" : "#DC0000")};
    transition: stroke-dashoffset 0.35s;
    transform: scaleX(-1);
    transform-origin: center;
  }
`;
export const Circle2 = styled(Circle)`
  width: 1012px;
  height: 1012px;
  border-radius: 506px;
  circle {
    fill: none;
    stroke-width: 30;
    stroke-linecap: round;
  }
`;

export const CircularProgress = styled.div<{ progress: number }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 812px;
  height: 812px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: scaleX(-1);

  &::before {
    z-index: 999;
    content: "";
    position: absolute;
    inset: 0;
    border-radius: 50%;
    background: conic-gradient(
      transparent ${(props) => 100 - props.progress}%,
      black ${(props) => 100 - props.progress}%
    );
  }
`;
export const CircularProgress2 = styled(CircularProgress)`
  width: 952px;
  height: 952px;
`;
export const TimerBackground = styled.div<{ backgroundImage: string }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: ${({ backgroundImage }) =>
    `url(${backgroundImage}) lightgray 50% / cover no-repeat`};
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  filter: blur(2.5px);
  opacity: 0.4;
  z-index: 0;
`;
export const TimerBox = styled.div`
  z-index: 1;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  > img {
    width: 113.305px;
    height: 104.418px;
    margin-bottom: 25.84px;
  }

  > .now-blind-wrapper {
    display: flex;
    flex-direction: column;
    gap: 10.68px;
    margin-top: 16.35px;
    > .title {
      color: #fff;
      text-align: center;
      font-family: "Termina Test";
      font-size: 35.313px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
    }

    > .value {
      > .next-blinds {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 5px;

        > .ante {
          color: #fff;
          font-family: "Termina Test";
          font-size: 42.621px;
          font-style: normal;
          font-weight: 900;
          line-height: 60.887px;
        }
        > .now-blinds {
          color: #fff;
          text-align: center;
          text-shadow: 0px 0px 37.365px rgba(100, 54, 231, 0.8);
          font-family: "Termina Test";
          font-size: 54.799px;
          font-style: normal;
          font-weight: 900;
          line-height: 60.887px; /* 111.111% */
        }
      }
    }
  }

  > .next-blind-wrapper {
    display: flex;
    flex-direction: column;
    gap: 8.41px;
    margin-top: 21.35px;
    margin-bottom: 30px;
    > .title {
      color: #b3b3b3;
      text-align: center;
      font-family: "Termina Test";
      font-size: 25.32px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
    }

    > .value {
      > .next-blinds {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 5px;

        > .ante {
          color: #b3b3b3;
          font-family: "Termina Test";
          font-size: 32.668px;
          font-style: normal;
          font-weight: 900;
          line-height: 46.668px;
        }
        > .now-blinds {
          color: #b3b3b3;
          text-align: center;
          font-family: "Termina Test";
          font-size: 42.001px;
          font-style: normal;
          font-weight: 900;
          line-height: 46.668px; /* 111.111% */
        }
      }
    }
  }

  > .now-level {
    margin-bottom: 3px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 345px;
    height: 79px;
    border-radius: 52.256px;
    background: rgba(255, 255, 255, 0.3);
    color: #fff;
    text-align: center;
    font-family: Pretendard;
    font-size: 37.738px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
  > .now-level.break {
    color: #fff;
    background: #f00;
  }
  > .time {
    color: #fff;
    text-align: center;
    font-family: Pretendard;
    font-size: 218.04px;
    font-style: normal;
    font-weight: 900;
    line-height: 100%; /* 218.04px */
    letter-spacing: -8.722px;
    text-shadow:
      0px 0px 50px rgba(255, 255, 255, 0.5),
      0px 0px 80px #f00;
    font-variant-numeric: tabular-nums;
  }

  > .time.level {
    color: #fff;
    text-shadow:
      0px 0px 30px rgba(255, 255, 255, 0.5),
      0px 0px 80px #6436e7;
  }
`;
export const UserTimeWrapper2 = styled.div`
  padding: 30px 20px 38px 30px;
  display: flex;
  flex-direction: row;
  gap: 20px;
  background: #363636;
  position: relative;
  color: white;
  max-width: 1920px;
  width: 100%;
  max-height: 1080px;
  height: 100%;
  box-sizing: border-box;

  > .left-wrapper {
    width: 1104px;
    display: flex;
    flex-direction: column;
    gap: 15px;
    z-index: 2;
    > .header {
      display: flex;
      flex-direction: row;
      gap: 20px;
      margin-bottom: 15px;
      > img {
        width: 150px;
        height: 150px;
        border-radius: 100%;
        object-fit: cover;
      }
      > .title {
        display: flex;
        flex-direction: column;

        > .pub-name {
          color: #fff;
          font-family: Pretendard;
          font-size: 30px;
          font-style: normal;
          font-weight: 500;
          line-height: normal;
          margin-bottom: 10px;
        }

        > .tournament {
          color: #fff;
          font-family: Pretendard;
          font-size: 50px;
          font-style: normal;
          font-weight: 700;
          line-height: normal;
        }

        > .type {
          margin-top: 4px;
          color: #fff;
          font-family: Pretendard;
          font-size: 35px;
          font-style: normal;
          font-weight: 500;
          line-height: normal;
        }
      }
    }

    > .item-wrapper.small {
      width: 372px;
    }

    > .item-wrapper {
      width: 452px;
      border-radius: 10px;
      background: #121212;
      display: flex;
      flex-direction: column;
      gap: 10px;
      justify-content: center;
      padding: 30px 30px;
      > .title {
        color: #979797;
        font-family: Pretendard;
        font-size: 30px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
      }

      > .value {
        color: #fff;
        font-family: Pretendard;
        font-size: 40px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
      }
    }
    > .next-blind-wrapper {
      width: 100%;
      border-radius: 35px;
      background: #000;
      display: flex;
      flex-direction: column;
      height: 321px;
      gap: 15px;
      justify-content: center;

      > .title {
        padding: 30px 30px 0px;
        color: rgba(255, 255, 255, 0.5);
        font-family: Pretendard;
        font-size: 35px;
        font-style: normal;
        font-weight: 900;
        line-height: normal;
      }

      > .value {
        padding: 0 30px 30px;
        color: rgba(255, 255, 255, 0.3);
        font-family: Pretendard;
        font-size: 80px;
        font-style: normal;
        font-weight: 900;
        line-height: 100px; /* 125% */
        letter-spacing: -2px;

        > .next-blinds.big {
          font-size: 70px;
        }

        > .ante {
          font-size: 70px;
          letter-spacing: 0px;
        }
      }
    }
    > .now-blind-wrapper {
      width: 100%;
      border-radius: 35px;
      background: #000;
      display: flex;
      flex-direction: column;
      height: 337px;
      gap: 15px;
      justify-content: center;

      > .title {
        padding: 30px 30px 0px;
        color: #fff;
        font-family: Pretendard;
        font-size: 45px;
        font-style: normal;
        font-weight: 900;
        line-height: normal;
      }

      > .value {
        padding: 0 30px 30px;
        color: #fff;
        font-family: Pretendard;
        font-size: 90px;
        font-style: normal;
        font-weight: 900;
        line-height: 100px;

        > .ante {
          font-size: 70px;
          letter-spacing: 0px;
        }
      }
    }
  }

  > .right-wrapper {
    width: 736px;
    display: flex;
    flex-direction: column;
    gap: 14px;
    align-items: flex-end;
    justify-content: space-between;
    z-index: 2;

    > .stack-wrapper {
      width: 100%;
      border-radius: 35px;
      background: #000;
      display: flex;
      flex-direction: row;
      height: 248px;
      align-items: center;
      justify-content: center;
      gap: 30px;

      > .line {
        width: 2px;
        height: 37px;
        background: #979797;
      }

      > .item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        > .title {
          color: #979797;
          font-family: Pretendard;
          font-size: 25px;
          font-style: normal;
          font-weight: 700;
          line-height: normal;
        }

        > .value {
          color: #fff;
          font-family: Pretendard;
          font-size: 40px;
          font-style: normal;
          font-weight: 750;
          line-height: normal;
        }
      }
    }
  }
`;

export const Timer2PrizeListContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 762px;
  align-items: flex-end;
  gap: 20px;
  > .header {
    padding: 30px 30px 0px 0px;
    color: #fff;
    font-family: "Termina Test";
    font-size: 50px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
`;

export const Timer2PrizeListWrapper = styled.div<{ subPrizeFont: number }>`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 5px;
  //1위
  > .item {
    display: flex;
    flex-direction: row;
    gap: 10px;
    width: 736px;
    height: 60px;
    padding: 5px 10px 5px 30px;
    align-items: center;
    border-radius: 15.04px;
    background: #121212;
    justify-content: space-between;

    &.rank1 {
      width: 658px;
    }

    &.rank2 {
      width: 566px;
    }

    > .prize-wrapper {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 15px;
      flex: 1;
      min-width: 0;

      > .prize {
        color: #fff;
        text-align: center;
        font-family: Pretendard;
        font-size: 35px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        font-variant-numeric: tabular-nums;

        > span {
          margin-right: 15px;
          font-size: 55px;
          letter-spacing: 1px;
        }
      }

      > .sub-prize {
        flex: 1;
        padding: 7.5px 18.5px;
        border-radius: 10px;
        background: #23388d;
        color: #fff;
        text-align: center;
        font-family: Pretendard;
        font-size: ${({ subPrizeFont }) =>
          subPrizeFont ? subPrizeFont + 5 : 25}px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        white-space: nowrap; /* 한 줄로 제한 */
        overflow: hidden; /* 넘치는 텍스트 숨김 */
        text-overflow: ellipsis;
      }
    }

    > .rank {
      font-family: Pretendard;
      font-size: 50px;
      font-style: normal;
      font-weight: 900;
      line-height: normal;
      background: linear-gradient(
        89deg,
        #f6ff00 3.92%,
        #fff 46.57%,
        #82de00 104.28%
      );
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
`;

export const Timer2PrizeListItemWrapper = styled.div<{
  length: number;
  subPrizeFont: number;
}>`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 500px;
  height: 45px;
  border-radius: 15.04px;
  background: #121212;
  padding: 10px;
  justify-content: space-between;
  gap: 8px;

  ${({ length }) =>
    length >= 12 &&
    css`
      animation: ${slideAnimation} 9s linear infinite;
    `}
  > .prize-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 15px;

    > .prize {
      color: #fff;
      text-align: center;
      font-family: Pretendard;
      font-size: 25px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      font-variant-numeric: tabular-nums;
      white-space: nowrap;

      > span {
        margin-right: 15px;
        font-size: 55px;
        letter-spacing: 1px;
      }
    }

    > .sub-prize {
      padding: 10.5px 15px;
      border-radius: 10px;
      background: #23388d;
      color: #fff;
      text-align: center;
      font-family: Pretendard;
      font-size: ${({ subPrizeFont }) => (subPrizeFont ? subPrizeFont : 20)}px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
    }
  }

  > .rank {
    color: #fff;
    font-family: Pretendard;
    font-size: 25px;
    font-style: normal;
    font-weight: 900;
    line-height: normal;
  }
`;

export const CircularTimerWrapper = styled.div`
  width: 856px;
  height: 856px;
  flex-shrink: 0;
  border-radius: 438px;
  background: #000;
  position: absolute;
  top: 188.66px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .dash-wrapper {
    position: absolute;
    top: 22px;
    left: 22px;
    width: 812px;
    height: 812px;
    > img {
      width: 812px;
      height: 812px;
    }
  }
`;

const slideAnimation = keyframes`
  0% {
    transform: translateY(50%);
    opacity: 0;
  }
  15% {
    transform: translateY(0);
    opacity: 1;
  }
  85% {
    transform: translateY(0);
    opacity: 1;
  }
  100% {
    transform: translateY(-30%);
    opacity: 0;
  }
`;

export const UserTimeWrapper = styled.div<MenuColor>`
  width: 100%;
  height: 100vh;
  background-image: url(${(props) => props.backgroundImage});
  color: ${(props) => props.fontColor};
  font-family: Pretendard;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  > .wrapper {
    width: 100%;
    padding: 42px 94px;
    display: flex;
    flex-direction: column;
    > .header {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      > .tournament-name {
        color: #fff;

        font-size: 40px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
      }

      > img {
        width: 154px;
        height: 55px;
      }
    }

    > .middle {
      width: 100%;
      margin-top: 34px;
      display: flex;
      flex-direction: row;
      gap: 32px;

      > .left-box {
        flex: 1114;
        aspect-ratio: 1114 / 544;
        border: 2px solid rgba(255, 255, 255, 0.3);
        border-radius: 40px;
        box-shadow: 0px 0px 24px 0px rgba(255, 255, 255, 0.4);
        background-color: ${(props) => props.menu1Color};

        > .header {
          margin: 38px 45px 87px;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          > .title {
            text-align: center;
            font-size: 50px;
            font-style: normal;
            font-weight: 900;
            line-height: normal;
          }

          > .info-box {
            display: flex;
            flex-direction: row;
            gap: 42px;
            font-size: 23px;
            font-style: normal;
            font-weight: 300;
            line-height: normal;

            > .time {
              width: 100px;
            }
            > span {
              font-weight: 700;
            }
            > .level {
              font-weight: 300;
              > span {
                font-weight: 700;
              }
            }
          }
        }

        > .timer-wrapper {
          margin-left: 45px;
          width: calc(100% - 45px);
          display: flex;
          flex-direction: row;
          gap: 38.54px;
          position: relative;
          > .now-level-wrapper {
            border-radius: 40px;
            border: 2px solid rgba(255, 255, 255, 0.3);
            // width: 206px;
            // height: 206px;
            width: 20%;
            aspect-ratio: 1/1;
            background: ${(props) => props.boxColor};
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            > .title {
              font-size: 35px;
              text-align: center;
              font-style: normal;
              font-weight: 400;
              line-height: normal;
              @media (min-width: 2051px) {
                font-size: 40px;
              }
            }
            > .now-level {
              height: 100px;
              font-size: 74px;
              font-weight: 700;
              line-height: normal;
              @media (min-width: 2051px) {
                font-size: 82px;
              }
            }
            > .now-level.break {
              font-size: 60px;
            }
          }

          > .timer {
            left: 284px;
            width: 770px;

            font-size: 250px;
            font-style: normal;
            font-weight: 900;
            line-height: normal;
          }
        }

        > .next-break {
          margin-left: 45px;
          margin-right: 45px;
          margin-top: 47px;

          padding: 10px 0;
          color: white;
          font-size: 30px;
          font-style: normal;
          font-weight: 600;
          line-height: normal;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 22px;
          border: 1px solid var(--Purple-300, #6436e7);
          background: ${(props) => props.buttonColor};
          @media (min-width: 2000px) and (max-width: 2100px) {
            padding: 12px 0;
            margin-top: 65px;
          }
          @media (min-width: 2101px) and (max-width: 2200px) {
            padding: 14px 0;
            margin-top: 75px;
          }
          @media (min-width: 2201px) and (max-width: 2300px) {
            padding: 14px 0;
            margin-top: 85px;
          }
          @media (min-width: 2301px) and (max-width: 2400px) {
            padding: 14px 0;
            margin-top: 95px;
          }
          @media (min-width: 2401px) and (max-width: 2500px) {
            padding: 16px 0;
            margin-top: 105px;
          }
          @media (min-width: 2501px) and (max-width: 2600px) {
            padding: 16px 0;
            margin-top: 115px;
          }
          > span {
            width: 100px;
            margin-left: 10px;
          }
        }
      }

      > .right-box {
        flex: 585;
        aspect-ratio: 585 / 544;
        border: 2px solid rgba(255, 255, 255, 0.3);
        border-radius: 40px;
        box-shadow: 0px 0px 24px 0px rgba(255, 255, 255, 0.4);
        background-color: ${(props) => props.menu2Color};
        display: flex;
        flex-direction: column;
        > .title {
          padding: 40px;
          font-size: 40px;
          font-style: normal;
          font-weight: 700;
          line-height: normal;
        }

        > .prize-list {
          padding: 0 40px;
          display: flex;
          flex-direction: column;
          gap: 10px;
          font-size: 25px;
          font-style: normal;
          font-weight: 700;
          line-height: normal;
          @media (min-width: 2000px) and (max-width: 2200px) {
            font-size: 25px;
          }
          @media (min-width: 2201px) and (max-width: 2300px) {
            font-size: 27px;
          }
          @media (min-width: 2301px) and (max-width: 2400px) {
            font-size: 28px;
          }
          @media (min-width: 2401px) and (max-width: 2500px) {
            font-size: 29px;
          }
          @media (min-width: 2501px) {
            font-size: 30px;
          }
          > .item {
            display: flex;
            flex-direction: row;
            gap: 16px;
            > .rank {
              width: 41px;
            }
            > .prize-wrapper {
              flex: 1;
              display: flex;
              flex-direction: row;
              justify-content: space-between;

              > .sub-prize {
                color: white;
                margin-left: 30px;
                display: flex;
                align-items: center;
                height: 30px;
                padding: 0 15px;
                border-radius: 21.265px;
                border: 0.473px solid var(--Purple-300, #6436e7);
                background: var(--Purple-300, #6436e7);
                font-size: 15px;
                font-style: normal;
                font-weight: 600;
                line-height: normal;
              }
            }
          }
        }
      }
    }

    > .bottom {
      margin-top: 40px;
      display: flex;
      flex-direction: row;
      gap: 32px;

      > .left-box {
        flex: 1114;
        aspect-ratio: 1114 / 332;

        display: flex;
        flex-direction: row;
        gap: 32.12px;

        > .box {
          flex: 1;
          height: 100%;
          border: 2px solid rgba(255, 255, 255, 0.3);
          border-radius: 40px;
          box-shadow: 0px 0px 24px 0px rgba(255, 255, 255, 0.4);
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 15px;
          > .title {
            text-align: center;
            font-size: 50px;
            font-style: normal;
            font-weight: 500;
            line-height: normal;
          }

          > .blind {
            text-align: center;
            font-size: 65px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
          }

          > .blind.next {
            font-weight: 400;
          }
        }

        > .box.a {
          background-color: ${(props) => props.menu3Color};
        }
        > .box.b {
          background-color: ${(props) => props.menu4Color};
          box-shadow: 0px 0px 24px 0px rgba(255, 255, 255, 0.3);
        }
      }

      > .right-box {
        flex: 585;
        aspect-ratio: 585 / 332;
        display: flex;
        flex-direction: row;
        gap: 31px;

        > .box {
          flex: 1;
          height: 100%;
          border: 2px solid rgba(255, 255, 255, 0.3);
          border-radius: 40px;
          box-shadow: 0px 0px 24px 0px rgba(255, 255, 255, 0.4);
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          > .list {
            display: flex;
            flex-direction: column;
            gap: 10px;
            > .box {
              display: flex;
              flex-direction: column;

              > .title {
                font-size: 18px;
                font-style: normal;
                font-weight: 700;
                line-height: normal;
                @media (min-width: 2000px) and (max-width: 2200px) {
                  font-size: 23px;
                }
                @media (min-width: 2201px) and (max-width: 2300px) {
                  font-size: 28px;
                }
                @media (min-width: 2301px) and (max-width: 2400px) {
                  font-size: 30px;
                }
                @media (min-width: 2401px) and (max-width: 2500px) {
                  font-size: 31px;
                }
                @media (min-width: 2501px) {
                  font-size: 32px;
                }
              }
              > .value {
                display: flex;
                justify-content: center;
                text-align: center;
                font-size: 22px;
                font-style: normal;
                font-weight: 650;
                line-height: normal;
                @media (min-width: 2000px) and (max-width: 2200px) {
                  font-size: 28px;
                }
                @media (min-width: 2201px) and (max-width: 2300px) {
                  font-size: 32px;
                }
                @media (min-width: 2301px) and (max-width: 2400px) {
                  font-size: 34px;
                }
                @media (min-width: 2401px) and (max-width: 2500px) {
                  font-size: 35px;
                }
                @media (min-width: 2501px) {
                  font-size: 36px;
                }
              }
            }
          }
        }

        > .box.a {
          background-color: ${(props) => props.menu5Color};
        }
        > .box.b {
          background-color: ${(props) => props.menu6Color};
        }
      }
    }
  }
`;

export const Timer1NoticeWrapper = styled.div`
  width: 596px;
  height: 177px;
  padding: 15px;
  border-radius: 10px;
  background: #121212;
  margin-top: 50px;
  box-sizing: border-box;

  .value {
    overflow: hidden;
    color: #fff;
    text-overflow: ellipsis;
    white-space: normal; /* nowrap을 제거하고 줄바꿈 허용 */
    font-family: "Termina Test";
    font-size: 25px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;

    line-height: 1.2; /* 줄 간격 설정 */
    text-overflow: ellipsis; /* 초과된 부분에 "..." 표시 */
    overflow-wrap: break-word;
    overflow: hidden; /* 내용이 넘치면 잘림 */
    display: -webkit-box; /* 웹킷 박스 모델로 설정 */
    -webkit-line-clamp: 5; /* 5줄로 제한 */
    -webkit-box-orient: vertical; /* 블록 방향 설정 */
  }
`;
